export default "__VITE_ASSET__C$ZX_Qw3__"